import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {formatErrors} from "../../../constants";
import {clientUpdateAction} from "../../../actions/clientAction";
import {toast} from "react-toastify";
import {InputUserForm} from "../../../utils/input/InputUserForm";

export function ClientRecentDiets({client, handleChange}) {
  const [edit, setEdit] = useState(false);
  const [form, setForm] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    setForm({
      recent_diets: client.recent_diets || '',
      recent_diet_programs: client.recent_diet_programs || ''
    });
  }, [client.recent_diets, client.recent_diet_programs]);

  const handleChangeForm = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setForm((form) => {
      return {...form, [name]: value}
    });
  };

  const handleCancel = () => {
    if (edit === 'loading') {
      return;
    }
    setForm({
      recent_diets: client.recent_diets || '',
      recent_diet_programs: client.recent_diet_programs || ''
    });
    setEdit(false);
  };

  const handleSave = () => {
    if (edit === 'loading') {
      return;
    }
    setEdit('loading');
    dispatch(clientUpdateAction(client.id, form)).then(() => {
      setEdit(false);
      handleChange(form);
    }).catch(err => {
      setEdit(true);
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  return <div className={"tabs__wrapper" + (edit ? " tabs__wrapper--edit" : "")}>
    {!edit && <React.Fragment>
      <span className="tabs__edit edit pointer" onClick={() => setEdit(true)}>Ред.</span>
      <div className="tabs__inner">
        <div className="tabs__heading">Диеты за последние 2-3 месяца</div>
        {client.recent_diets && <p className="tabs__value">{client.recent_diets}</p>}
        {!client.recent_diets && <p className="tabs__value">&mdash;</p>}
      </div>
      <div className="tabs__inner">
        <div className="tabs__heading">Какие программы похудения вы проходили прежде?</div>
        {client.recent_diet_programs && <p className="tabs__value">{client.recent_diet_programs}</p>}
        {!client.recent_diet_programs && <p className="tabs__value">&mdash;</p>}
      </div>
    </React.Fragment>}
    {edit && form && <React.Fragment>
      <div className="tabs__inner">
        <div className="tabs__heading">Диеты за последние 2-3 месяца</div>
        <div className="tabs__value">
          <InputUserForm type="text" value={form.recent_diets} name="recent_diets" disabled={edit === 'loading'} onChange={handleChangeForm}/>
        </div>
      </div>
      <div className="tabs__inner">
        <div className="tabs__heading">Какие программы похудения вы проходили прежде?</div>
        <div className="tabs__value">
          <InputUserForm type="text" value={form.recent_diet_programs} name="recent_diet_programs" disabled={edit === 'loading'} onChange={handleChangeForm}/>
        </div>
      </div>
      <div className="tabs__buttons">
        <span className="tabs__btn tabs__btn--canceling btn pointer" onClick={handleCancel}>Отменить</span>
        <span className="tabs__btn tabs__btn--save btn pointer" onClick={handleSave}>Сохранить</span>
      </div>
    </React.Fragment>}
  </div>;
}
